// extracted by mini-css-extract-plugin
module.exports = {"asideWidth":"200px"};